import React, { Component } from 'react';
import { Modal, Button, Table, Form, Input, Divider, message, Select, DatePicker, Tabs, Tooltip } from 'antd';
import axios from '../../service/index'
import './userlist.less'
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
class Userlist extends Component {

	constructor(props) {
		super(props)
		this.state = {
			visible: false,
			lableListData: [],
			enrollmentChannelList: [],
			phone: '',
			endTime: '',
			startTime: '',
			isHas: 0,
			sourceType: undefined,
			zsChannelId: undefined,
			autoSyn: 0,
			total: 0,
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			isTeacher: 2,
			labelName: '',
			allowClear: false,
			labelId: null,
			modelTitle: '新建标签',
			columnsConsultant: [
				{
					title: '电话号码',
					dataIndex: 'phone',
					key: 'phone',
					// width: 'center'
					minWidth: '150px',
					ellipsis: true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
					)
				},
				{
					title: '微信昵称',
					dataIndex: 'nickName',
					key: 'nickName',
					align: 'center'
				},
				{
					title: '部门',
					dataIndex: 'groupName',
					key: 'groupName',
					align: 'center'
				},
				{
					title: '姓名',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center',
				},
				{
					title: '注册时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				}
			],
			columns: [
				{
					title: '电话号码',
					dataIndex: 'phone',
					key: 'phone',
					ellipsis: true,
					width: '130px'
				},
				{
					title: '微信昵称',
					dataIndex: 'nickName',
					key: 'nickName',
					align: 'center',
					ellipsis: true,
					width: '150px'
				},
				{
					title: '意向学科',
					dataIndex: 'intendedCourse',
					key: 'intendedCourse',
					align: 'center',
					width: '100px'
				},
				{
					title: '年龄',
					dataIndex: 'age',
					key: 'age',
					align: 'center',
				},
				{
					title: '学历',
					dataIndex: 'educational',
					key: 'educational',
					align: 'center',
				},
				{
					title: '城市',
					dataIndex: 'city',
					key: 'city',
					align: 'center',
				},
				{
					title: '注册时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center',
					ellipsis: true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
					)
				},
				{
					title: '裂变人',
					dataIndex: 'kefuName',
					key: 'kefuName',
					align: 'center',
					width: '90px'
				},
        {
					title: '裂变人所属部门',
					dataIndex: 'groupName',
					key: 'groupName',
					align: 'center',
					width: '140px'
				},
				{
					title: '用户来源',
					dataIndex: 'sourceType',
					key: 'sourceType',
					align: 'center',
					width: '110px',
					render: (record) => {
						if (record === 1) {
							return '裂变'
						}
						if (record === 2) {
							return '自然流量'
						}
						if (record === 3) {
							return '官网扫二维码'
						}
					}
				},
				{
					title: '招生渠道',
					dataIndex: 'zsChannelName',
					key: 'zsChannelName',
					align: 'center',
					width: '120px'
				},
				{
					title: '是否重量',
					dataIndex: 'isHas',
					key: 'isHas',
					align: 'center',
					width: '90px',
					render: (record) => {
						if (record === 1) {
							return '是'
						}
						if (record === 0) {
							return '否'
						}
					}
				},
				{
					title: '是否同步',
					dataIndex: 'autoSyn',
					key: 'autoSyn',
					align: 'center',
					width: '90px',
					render: (record) => {
						if (record === 0) {
							return '未同步'
						}
						if (record === 1) {
							return '已同步'
						}
					}
				}
			]
		}
	}
	componentDidMount() {
		this.lableList()
    this.getEnrollmentChannelList()
	}
	componentWillUnmount() {
		this.setState = ()=>false;
	}
	showModal = (e) => {
		this.setState({
			modelTitle: '新增标签',
			visible: true
		})

	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			console.log(err, values)
			if (!err) {
				if (this.state.modelTitle === '新增标签') {
					axios.post('labelController/add', {
						name: values.name
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加成功')
							this.lableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
				} else {
					axios.post('labelController/update', {
						name: values.name,
						id: this.state.labelId
					}).then(res => {
						console.log(res)
						if (res.data.code === '200') {
							message.success('编辑成功')
							this.lableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
				}

			}
		})
	}
	lableList = () => {
		axios.post('userController/getList', {
			...this.state.searchData,
			phone: this.state.phone,
			isHas: this.state.isHas,
			startTime: this.state.startTime,
			endTime: this.state.endTime,
			isTeacher: this.state.isTeacher,
			autoSyn: this.state.autoSyn,
			sourceType: this.state.sourceType,
			zsChannelId: this.state.zsChannelId
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					lableListData: res.data.data.list,
					total: res.data.data.total
				})
			}
		})
	}
	getEnrollmentChannelList = () => {
		axios.get('/jumpUrlConfigController/getZsChannel').then(({data: res}) => {
			if (res.code === '200') {
				this.setState({
					enrollmentChannelList: res.data
				})
			}
		})
	}
	delLable(id) {
		axios.get(`labelController/del/${id}`).then(res => {
			if (res.data.code === '200') {
				message.success('删除成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	exportData(){
		// window.location.href = `http://192.168.40.55:8686/video-wechat-manager/api/userController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}&autoSyn=${this.state.autoSyn}&isHas=${this.state.isHas}&isTeacher=${this.state.isTeacher}`
		axios.get(`/userController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}&autoSyn=${this.state.autoSyn}&isHas=${this.state.isHas}&isTeacher=${this.state.isTeacher}&sourceType=${this.state.sourceType === undefined ? '' : this.state.sourceType}&zsChannelId=${this.state.zsChannelId === undefined ? '' : this.state.zsChannelId}`,{responseType: 'blob'}).then(res =>{
			const link = document.createElement('a')
			let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.setAttribute('download', '用户列表.xlsx')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		})
	}
	callback=(key)=> {
		this.setState({
			isTeacher: key
		}, ()=>{
			this.lableList()
		})
	  }
	render() {
		const { lableListData, modelTitle, columns,columnsConsultant,visible, isTeacher,labelName, total } = this.state
		const { getFieldDecorator } = this.props.form;
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		return (
			<div className="userlist">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>学习站用户管理</span>
				<Divider />
				<Tabs defaultActiveKey="2" onChange={this.callback}>
					<TabPane tab="学生" key="2"></TabPane>
					<TabPane tab="咨询师" key="1"></TabPane>

				</Tabs>
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{display: 'flex',flexWrap: 'wrap'}}>
						<Input allowClear value={this.state.phone} style={{ width: '160px', height: '40px', marginRight: '20px', marginBottom: '20px' }}
							placeholder="手机号码"
							onChange={(e) => {
								this.setState({
										phone: e.target.value
								})
							}}
						></Input>
						<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
							<span>招生渠道：</span>
							<Select  allowClear
                  showSearch
                  optionFilterProp="children" placeholder="招生渠道" value={this.state.zsChannelId} style={{ width: 160, height: '40px' }} onChange={(value)=>{
								this.setState({
									zsChannelId: value
								})
							}}>
								{this.state.enrollmentChannelList.map(item=>{
										return (<Option key={item.did} value={item.did}>{item.dname}</Option>)
									})}
							</Select>
						</div>
						<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
							<span>来源：</span>
							<Select  placeholder="学生来源" value={this.state.sourceType} style={{ width: 120, height: '40px' }} onChange={(value)=>{
								this.setState({
									sourceType: value
								})
							}}>
								<Option value={1}>裂变</Option>
								<Option value={2}>自然流量</Option>
								<Option value={3}>官网二维码</Option>
							</Select>
						</div>
						<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
							<span>是否重量：</span>
							<Select  placeholder="是否重量" value={this.state.isHas} style={{ width: 120, height: '40px' }} onChange={(value)=>{
								this.setState({
									isHas: value
								})
							}}>
								<Option value={0}>全部</Option>
								<Option value={1}>是</Option>
								<Option value={2}>否</Option>
							</Select>
						</div>
						<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
							<span>是否同步：</span>
							<Select  placeholder="是否同步" value={this.state.autoSyn} style={{ width: 120, height: '40px' }} onChange={(value)=>{
								this.setState({
									autoSyn: value
								})
							}}>
								<Option value={0}>全部</Option>
								<Option value={1}>已同步</Option>
								<Option value={2}>未同步</Option>
							</Select>
						</div>
						<RangePicker onChange={(date, dateString)=>{
							console.log(date, dateString);
							this.setState({
									startTime: dateString[0],
									endTime: dateString[1]

							})
						}} />
						<Button className='my-button-primary' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.setState({
								allowClear: true,
									phone: '',
									isHas: 0,
									autoSyn: 0,
									startTime: '',
									endTime: '',
									searchData: {
										pageSize: 10,
										pageNum: 1,
									},
									sourceType: undefined,
									zsChannelId: undefined
							},()=>{
								this.lableList()
							})
						}}>重置</Button>
					</div>
					<div>
					<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
						this.exportData()
						}}>导出</Button>
					</div>
				</div>
				{ (isTeacher === '1') ?  <Table pagination={pagination} dataSource={lableListData} columns={ columnsConsultant} rowKey={record => record.id} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}/> :
				<Table pagination={pagination} dataSource={lableListData} columns={	columns} rowKey={record => record.id} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}/> }
				<Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk}>
						<Form.Item label={"标签名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入标签名称!', }],
								initialValue: modelTitle === '编辑标签' ? labelName : ''
							})(
								<Input placeholder='请输入标签名称' />
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}

};

export default Form.create()(Userlist)